<template>
  <div class="tender-list-general-estimate-drop-zone h3">
    <span>{{ $t('Drop here to apply this price to the general estimate') }}</span>
  </div>
</template>

<script>
  export default {
    name: 'TenderListGeneralEstimateDrop',
  };
</script>
